<template>
  <div class="payment-details">

    <CreditCard v-for="card in cards"
                :card="card"
                :key="card.id"/>

    <div v-if="!cards || !cards.length"
         class="empty-state">
      <div class="empty-state-title empty-state-content">
        {{$t('client.matters.matter_page.contact.payments.no_cards')}}
      </div>
      <div class="empty-state-cta empty-state-content"
           @click="addCard"
           v-if="canAddCards">
        <v-icon>icon-Plus</v-icon>
        {{$t('client.matters.matter_page.add_card')}}
      </div>
    </div>

    <div v-else-if="canAddCards"
         class="empty-state non-empty">
      <div class="empty-state-cta empty-state-content"
           @click="addCard">
        <v-icon>icon-Plus</v-icon>
        {{$t('client.matters.matter_page.add_card')}}
      </div>
    </div>

  </div>
</template>

<script>
  import CreditCard from "./CreditCard";
  import {mapGetters} from "vuex";

  export default {
    name: "PaymentDetails",
    components: { CreditCard },
    props: {
      cards: {
        type: Array,
        required: true
      },
      origin: {
        type: String
      }
    },
    computed: {
      ...mapGetters(['isPane', 'isMobile', 'isMobileApp', 'angularOrigin']),
      canAddCards() {
        return this.$hasPermission('can_refund');
      },
      inboxReadingPaneMixpanelFF() {
        return this.$hasFeature('inbox_reading_pane_mixpanel')
      }
    },
    methods: {
      addCard() {
        let origin = 'Client card';
        if(this.inboxReadingPaneMixpanelFF && (!this.isMobile || !this.isMobileApp)) {
          origin = this.isPane ? `Right pane matter card - ${this.angularOrigin}` : 'Full page matter card';
        }
        this.$frontageApi.send('matter_action', {action: 'add_credit_card', amount_of_cards: this.cards.length, origin});
      }
    }
  }
</script>

<style scoped lang="scss">
  .payment-details {
    margin-bottom: -10px;
  }

  .empty-state {
    margin-bottom: 10px;
  }
</style>
